import { Link } from 'react-router-dom';
import DashboardLayout from '../components/DashboardLayout';
import StatsCards from '../components/StatsCards';
import { useAuth } from '../context/AuthContext';

const DashboardPage = () => {
  const { user } = useAuth();
  const profileSummary = [
    { label: 'Name', value: user ? `${user.first_name} ${user.surname}` : '—' },
    { label: 'Email', value: user?.email || '—' },
    { label: 'Username', value: user?.username || '—' }
  ];

  return (
    <DashboardLayout title="Overview">
      <div className="card hero-card" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1.5rem' }}>
        <div>
          <span className="eyebrow">Identity platform</span>
          <h3 style={{ margin: '0.4rem 0' }}>Welcome back to Gate.haus</h3>
          <p style={{ color: 'var(--dark)' }}>
            Keep your digital identity in sync. Use the quick links to jump into the area you want to manage next.
          </p>
        </div>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <Link className="nav-link active" to="/identity">
            Identity
          </Link>
          <Link className="nav-link" to="/security">
            Security
          </Link>
          <Link className="nav-link" to="/apps">
            Apps
          </Link>
        </div>
      </div>
      <StatsCards />
      <div className="dashboard-grid" style={{ alignItems: 'stretch' }}>
        <div className="card">
          <div className="section-header">
            <div>
              <span className="eyebrow">Profile</span>
              <h3 style={{ margin: '0.2rem 0' }}>Identity snapshot</h3>
              <p>Quick reference for your Gate.haus identity.</p>
            </div>
            <span className="badge">Identity</span>
          </div>
          <ul style={{ listStyle: 'none', padding: 0, margin: '1rem 0 0', display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
            {profileSummary.map((item) => (
              <li key={item.label} style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ color: 'var(--gray)' }}>{item.label}</span>
                <strong>{item.value}</strong>
              </li>
            ))}
          </ul>
        </div>
        <div className="card">
          <div className="section-header">
            <div>
              <span className="eyebrow">Navigation</span>
              <h3 style={{ margin: '0.2rem 0' }}>Where to next?</h3>
              <p>Use these steps to keep your identity fresh.</p>
            </div>
          </div>
          <ul style={{ paddingLeft: '1rem', color: 'var(--gray)' }}>
            <li>Update your profile info from the Identity section.</li>
            <li>Manage TOTP and passkeys inside Security.</li>
            <li>Review connected applications within Apps.</li>
          </ul>
        </div>
      </div>
    </DashboardLayout>
  );
};

export default DashboardPage;
